import React, { forwardRef } from 'react';
import styled from 'styled-components';

const StyledSafariFocusHolderInput = styled.input`
  position: absolute;
  border: none;
  outline: none;
  opacity: 0;
  height: 0;
  width: 0;
`;

const SafariFocusHolderInput = forwardRef<HTMLInputElement>((_, ref) => {
  return (
    <StyledSafariFocusHolderInput
      type="text"
      readOnly
      tabIndex={-1}
      aria-hidden
      ref={ref}
    />
  );
});

export default SafariFocusHolderInput;
